<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  flex-grow: 1;
}
body {
  min-height: 100vh;
  margin: 0;
  display: flex;
}
textare, input, button {
  border-radius: 0!important;
}
</style>
